function CRMIco({ color }) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 17V15.2222C19 13.5655 17.8527 12.1734 16.3 11.7787M13.15 1.25845C14.4693 1.78591 15.4 3.06339 15.4 4.55556C15.4 6.04772 14.4693 7.3252 13.15 7.85266M14.5 17C14.5 15.3433 14.5 14.515 14.226 13.8616C13.8606 12.9904 13.1598 12.2982 12.2777 11.9373C11.6161 11.6667 10.7774 11.6667 9.1 11.6667H6.4C4.72261 11.6667 3.88392 11.6667 3.22234 11.9373C2.34024 12.2982 1.63941 12.9904 1.27403 13.8616C1 14.515 1 15.3433 1 17M11.35 4.55556C11.35 6.51923 9.73822 8.11111 7.75 8.11111C5.76177 8.11111 4.15 6.51923 4.15 4.55556C4.15 2.59188 5.76177 1 7.75 1C9.73822 1 11.35 2.59188 11.35 4.55556Z"
        stroke="#5DC122"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default CRMIco;
